"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ZeroDevSessionKeyPlugin__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "key",
                type: "address"
            },
        ],
        name: "SessionKeyRevoked",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_packed",
                type: "bytes"
            },
        ],
        name: "parseDataAndSignature",
        outputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes"
            },
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_key",
                type: "address"
            },
        ],
        name: "revokeSessionKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_key",
                type: "address"
            },
        ],
        name: "revoked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_key",
                type: "address"
            },
        ],
        name: "sessionNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "initCode",
                        type: "bytes"
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes"
                    },
                    {
                        internalType: "uint256",
                        name: "callGasLimit",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "verificationGasLimit",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "preVerificationGas",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "maxFeePerGas",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "maxPriorityFeePerGas",
                        type: "uint256"
                    },
                    {
                        internalType: "bytes",
                        name: "paymasterAndData",
                        type: "bytes"
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes"
                    },
                ],
                internalType: "struct UserOperation",
                name: "userOp",
                type: "tuple"
            },
            {
                internalType: "bytes32",
                name: "userOpHash",
                type: "bytes32"
            },
            {
                internalType: "uint256",
                name: "missingAccountFunds",
                type: "uint256"
            },
        ],
        name: "validatePluginData",
        outputs: [
            {
                internalType: "bool",
                name: "validated",
                type: "bool"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var ZeroDevSessionKeyPlugin__factory = /** @class */ (function (_super) {
    __extends(ZeroDevSessionKeyPlugin__factory, _super);
    function ZeroDevSessionKeyPlugin__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    ZeroDevSessionKeyPlugin__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ZeroDevSessionKeyPlugin__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ZeroDevSessionKeyPlugin__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ZeroDevSessionKeyPlugin__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ZeroDevSessionKeyPlugin__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    ZeroDevSessionKeyPlugin__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    ZeroDevSessionKeyPlugin__factory.bytecode = _bytecode;
    ZeroDevSessionKeyPlugin__factory.abi = _abi;
    return ZeroDevSessionKeyPlugin__factory;
}(ethers_1.ContractFactory));
exports.ZeroDevSessionKeyPlugin__factory = ZeroDevSessionKeyPlugin__factory;
